import React, { Component } from 'react';
import DatePicker from 'react-datepicker';
class DisbursmentAndPaymentFilter extends Component {
  state = {
    dateStart: this.props.state.dateStart,
    dateEnd: this.props.state.dateEnd,
  };

  componentDidUpdate(prevProps) {
    if (prevProps.state !== this.props.state) {
      this.setState({
        dateStart: this.props.state.dateStart,
        dateEnd: this.props.state.dateEnd,
      });
    }
  }

  handleChange = this.props.handleChange;
  handleChangeDate = this.props.handleChangeDate;
  handleFilter = this.props.handleFilter;

  render() {
    return (
      <div>
        <div className="m-4"></div>
        <div className="card">
          <div className="card-body">
            <h5 className="card-title">
              <i className="fas fa-filter mr-2"></i>
              Filtro
            </h5>
            <form
              onSubmit={this.handleFilter}
              className="row align-items-start position-relative"
            >
              {this.props.inputDateEnabled !== true && (
                <div className="col-md-6 form-group d-flex flex-column">
                  <label htmlFor="fecha">Rango de fechas</label>
                  <div className="d-flex">
                    <DatePicker
                      className="form-control mr-1"
                      locale="es"
                      selected={this.state.dateStart}
                      dateFormat="dd/MM/yyyy"
                      onChange={(date) =>
                        this.handleChangeDate(date, 'dateStart')
                      }
                      selectsStart
                      startDate={this.state.dateStart}
                      endDate={this.state.dateEnd}
                      showDisabledMonthNavigation
                      shouldCloseOnSelect={false}
                      placeholderText="Fecha de Inicio"
                      required
                    />
                    <DatePicker
                      className="form-control ml-1"
                      locale="es"
                      selected={this.state.dateEnd}
                      dateFormat="dd/MM/yyyy"
                      onChange={(date) =>
                        this.handleChangeDate(date, 'dateEnd')
                      }
                      selectsEnd
                      startDate={this.state.dateStart}
                      endDate={this.state.dateEnd}
                      minDate={this.state.dateStart}
                      showDisabledMonthNavigation
                      shouldCloseOnSelect={false}
                      placeholderText="Fecha de Fin"
                      required
                    />
                  </div>
                </div>
              )}

              <div className="col-12"></div>
              <div className="col-3 mt-2 form-group">
                <button type="submit" className="btn btn-primary btn-block">
                  Aplicar
                </button>
              </div>
            </form>
          </div>
        </div>
        <div className="m-4"></div>
      </div>
    );
  }
}

export default DisbursmentAndPaymentFilter;
